import { render } from "./NazarPage.vue?vue&type=template&id=517293e0"
import script from "./NazarPage.vue?vue&type=script&lang=js"
export * from "./NazarPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ronachoob-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__